/**
 * System Prompt Builder Types
 *
 * Standardized types for building agent system prompts with 5 mandatory sections.
 */
/**
 * Default section headers
 */
export const DEFAULT_SECTION_HEADERS = {
    intro: 'Overview',
    tools: 'Available Tools',
    suggestions: 'Best Practices',
    contextNote: 'Context Engineering',
    evaluation: 'Evaluation Criteria',
};
/**
 * Default separator between sections
 */
export const DEFAULT_SEPARATOR = '\n\n---\n\n';
